module.exports = __webpack_public_path__ + "img/invoices_inactive.079036ef.svg";